// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.block-speakers--element {
  background-color: var(--speakers-bg-color);
}
.block-speakers--element .block-speakers__title {
  color: var(--sections-title-color) !important;
}
.block-speakers--element .speaker-card {
  background-color: var(--speakers-card-bg-color);
  padding: var(--speakers-card-padding);
}
.block-speakers--element .speaker-card__name {
  color: var(--speakers-name-color);
}
.block-speakers--element .speaker-card__role {
  color: var(--speakers-role-color);
}
.block-speakers--element .speaker-card__description {
  color: var(--speakers-description-color);
}
.block-speakers--element .speaker-card .ant-collapse-expand-icon {
  color: var(--speaker-explode-icon-color) !important;
}
.block-speakers--element .block-speakers__card-wrapper {
  display: flex;
  flex-direction: column;
}
.block-speakers--element .block-speakers__card-wrapper .speaker-card {
  flex: 1;
}
.block-speakers--element .block-speakers__card-wrapper--bordered .speaker-card {
  border: 1px solid var(--speakers-card-border-color);
}
.block-speakers--drawer .speaker-card {
  background-color: var(--speakers-drawer-card-bg-color);
}
.block-speakers--drawer .speaker-card__name {
  color: var(--speakers-drawer-name-color);
}
.block-speakers--drawer .speaker-card__role {
  color: var(--speakers-drawer-role-color);
}
.block-speakers--drawer .speaker-card__description {
  color: var(--speakers-drawer-description-color);
}
.block-speakers--drawer .speaker-card .ant-collapse-expand-icon {
  color: var(--speakers-drawer-explode-icon-color) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/blocks/Speakers/Speakers.scss"],"names":[],"mappings":"AACI;EACI,0CAAA;AAAR;AAEQ;EACI,6CAAA;AAAZ;AAGQ;EACI,+CAAA;EACA,qCAAA;AADZ;AAGY;EACI,iCAAA;AADhB;AAIY;EACI,iCAAA;AAFhB;AAKY;EACI,wCAAA;AAHhB;AAMY;EACI,mDAAA;AAJhB;AASI;EACI,aAAA;EACA,sBAAA;AAPR;AASQ;EACI,OAAA;AAPZ;AAYQ;EACI,mDAAA;AAVZ;AAeQ;EACI,sDAAA;AAbZ;AAeY;EACI,wCAAA;AAbhB;AAgBY;EACI,wCAAA;AAdhB;AAiBY;EACI,+CAAA;AAfhB;AAkBY;EACI,2DAAA;AAhBhB","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
